import { render, staticRenderFns } from "./uni.vue?vue&type=template&id=5b68482c&scoped=true&"
import script from "./uni.vue?vue&type=script&lang=js&"
export * from "./uni.vue?vue&type=script&lang=js&"
import style0 from "./uni.vue?vue&type=style&index=0&id=5b68482c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68482c",
  null
  
)

export default component.exports